import Vue from 'vue'
import { Pop, Notif } from '@sneppy/vue-pop'

Vue.use(Pop, {bWithNotif: true})

const pop = new Pop(['notif'])
const notif = new Notif(pop)

export default pop
export { pop, notif }